export default "__VITE_ASSET__D5K09XBS__"